import { Buffer } from "buffer";

export const packUUID = (uuid: string) => {
  const buffer = Buffer.from(uuid.replaceAll("-", ""), "hex");
  return buffer.toString("base64").replaceAll("+", "-").replaceAll("/", "_");
};

export const unpackUUID = (packed: string) => {
  if (maybeUUID4(packed)) {
    return packed;
  }
  const buffer = Buffer.from(
    packed.replaceAll("-", "+").replaceAll("_", "/") + "==\n",
    "base64"
  );
  const uuid = buffer.toString("hex");
  return [
    uuid.slice(0, 8),
    uuid.slice(8, 12),
    uuid.slice(12, 16),
    uuid.slice(16, 20),
    uuid.slice(20),
  ].join("-");
};

export function maybeUUID4(packed: string): boolean {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(packed);
}

export const handleCancel = (cb?: () => void) => {
  const wrapped = (evt: React.MouseEvent) => {
    evt.preventDefault();
    cb?.();
  };
  return wrapped;
};
